<template>
  <div class="container">


    <div class="header">
      <div class="inner_center">
        <h1>潮国创意企业PLUS授权</h1>
        <h2>致力于为企业/机构提供创意定制服务，为商用授权保驾护航</h2>

        <div class="btn-group">
          <a :href="SERVICE_LINK" target="_blank" class="btn btn_consult">免费咨询</a>
          <a href="/introduce/company" target="_blank" class="btn btn_back">返回企业首页</a>
        </div>
      </div>

      <!-- 权益列表  -->

      <div class="list-box">
        <div class="inner_center">
          <div class="list-item">
            <div class="IconItem_0"/>
            <div class="bar">
              <div class="title">企业专享内容</div>
              <div class="desc">商用授权，免费咨询</div>
            </div>
          </div>
          <div class="list-item">
            <div class="IconItem_1"/>
            <div class="bar">
              <div class="title">子账号赋权</div>
              <div class="desc">专属服务平台</div>
            </div>
          </div>
          <div class="list-item">
            <div class="IconItem_2"/>
            <div class="bar">

              <div class="title">团队共享收藏夹</div>
              <div class="desc">一键收藏，更便捷</div>
            </div>


          </div>
          <div class="list-item">
            <div class="IconItem_3"/>
            <div class="bar">
              <div class="title">在线下载授权书</div>
              <div class="desc">更直观的授权保障</div>
            </div>
          </div>
          <div class="list-item">
            <div class="IconItem_4"/>
            <div class="bar">
              <div class="title">免费定制服务</div>
              <a href="https://chaopx.com/fans/demand-pool" target="_blank">去体验 ></a>

              <i class="icon_float">限时海量</i>
            </div>

          </div>
          <div class="list-item">
            <div class="IconItem_5"/>
            <div class="bar">
              <!--              <div class="title">每日签到有礼</div>
                            <a href="https://chaopx.com/fans-club" target="_blank">去体验 ></a>-->
              <div class="title">营销日历自定义日程</div>
              <a :href="CALENDAR" target="_blank">去体验 ></a>
            </div>
          </div>
          <!--          <div class="list-item">
                      <div class="IconItem_6"/>
                      <div class="bar">
                        <div class="title">拉新返利</div>
                        <a href="https://chaopx.com/fans-club" target="_blank">去体验 ></a>
                      </div>
                    </div>-->
        </div>
      </div>


    </div>


    <div class="custom-service-box">

      <div class="title">
        符合以下情况，皆可咨询客服定制报价 <br>
        全方位满足您的需求
      </div>

      <div class="card">
        <i class="icon_service"></i>
        <i class="icon_custom">Customized Services</i>
        <div class="card-left">
          <ul>
            <li>
              <i class="icon_biao"/>
              公司注册资本＞2000万
            </li>
            <li>
              <i class="icon_biao"/>
              根据需求→定制授权范围
            </li>
            <li>
              <i class="icon_biao"/>
              根据员工数量→定制子账号数量
            </li>
            <li>
              <i class="icon_biao"/>
              根据甲方数量→定制主体数量
            </li>
          </ul>

        </div>
        <div class="card-right">

          <div class="modal">
            <div class="title">客户经理为您服务</div>
            <div class="desc">联系在线客户随时为您响应</div>
            <a :href="SERVICE_LINK" target="_blank" class="btn">在线咨询</a>
          </div>

        </div>
      </div>

    </div>


    <div class="vip-card-group">
      <div class="inner_center">
        <div class="title">常见大型企业授权 · 可咨询报价</div>

        <!-- 授权列表 -->
        <div class="mandate-list ">
          <div class="mandate-item"
               v-for="item in MANDATE_LIST"
               :key="item.title"
          >

            <div class="title">{{ item.title }}</div>
            <div class="member">{{ item.member }}</div>

            <div class="list">
              <div class="list-item"
                   v-for="subItem in item.list"
                   :key="subItem"
              >
                <i class="iconfont icon-gou2"/>
                {{ subItem }}


              </div>
            </div>

            <a :href="SERVICE_LINK" target="_blank" class="btn">咨询报价</a>

            <div class="IconItem2 IconItem2_0" v-if="item.id === 1"/>
            <div class="IconItem2 IconItem2_1" v-if="item.id === 2"/>
            <div class="IconItem2 IconItem2_2" v-if="item.id === 3"/>
            <div class="IconItem2 IconItem2_3" v-if="item.id === 4"/>

          </div>
        </div>

        <div class="card-item-list _hide">
          <div
            :class="vo.className"
            class="card-item"
            v-for="(vo,idx) in vipCardList"
            :key="vo.value"
          >
            <div
              class="card-header"
              :class="'card-header' + (idx+1)"
            >
              <div class="title">{{ vo.name }}</div>
              <div class="sub-title _hide" v-if="vo.subTitle">
                <span class="text-main">{{ vo.subTitle.main }}</span>
                |
                <span class="text-account">{{ vo.subTitle.account }}</span>
              </div>
            </div>
            <div class="card-content">
              <div class="price-box" v-if="vo.ID != -1">
                <i class="icon_dollar">￥</i>
                <span class="price">{{ vo.price }}</span>
                <span class="time">{{ vo.time }}</span>
              </div>
              <div class="price-box2" v-else>
                按需定制
              </div>

              <div class="main-box" v-if="vo.subTitle">
                <div class="sub-title ">
                  <span class="text-main">{{ vo.subTitle.main }}</span> <br>
                  <span class="text-account">{{ vo.subTitle.account }}</span>
                </div>
                <!--                <div class="down-num">
                                  {{ vo.downNum }}
                                </div>-->
              </div>
              <div class="buy" v-if="vo.ID != -1" @click="buy(vo)">
                {{ '立即开通' }}

                <div class="common-tag">限时买1年送1年</div>

              </div>
              <div class="buy buy-service" v-else @click="buy(vo)">
                {{ '立即咨询' }}
              </div>

              <div class="scene-hr scene-hr-team">
                <div class="scene-text">
                  {{ '权益保障' }}
                </div>
              </div>
              <div class="permission-list interests">
                <div
                  v-for="(permItem,permIdx) in vo.interests.slice(0,1)"
                  :key="permIdx"
                  class="permission-item"
                  @click="showCertificate(vo)"

                >
                  <i :class="['iconfont','icon-gou2']"/>
                  <span>{{ permItem }}</span>
                </div>

                <div
                  v-for="(permItem,permIdx) in vo.interests.slice(1)"
                  :key="permIdx"
                  class="permission-item"
                >
                  <i :class="['iconfont','icon-gou2']"/>
                  <span>{{ permItem }}</span>
                </div>
              </div>

              <div class="scene-hr scene-hr-team">
                <div class="scene-text">
                  {{ '授权范围' }}
                </div>
              </div>

              <div class="permission-list">
                <div
                  v-for="(permItem,permIdx) in vo.scope"
                  :key="permIdx"
                  class="permission-item">
                  <i :class="['iconfont','icon-gou2']"/>
                  <span>{{ permItem }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>


    <!-- 授权范围  -->
    <div class="mandate-scope">

      <div class="inner_center">
        <div class="title">企业PLUS授权范围</div>
        <div class="content">

          <div
            v-for="vo in mandateScope"
            :key=" 'interestsParent' + vo.label "
            class="rights-and-interests authorization-item"
          >
            <!--              <div class="title">{{ vo.label }}</div>-->
            <ul>
              <li
                v-for="(item,index) in vo.list"
                :class=" { 'NO': !item.value } "
                :key=" 'interests' + item.label ">
                <div
                  class="name"
                >
                  {{ item.label }}

                  <template v-if="index !== 0">
                    <span v-if="item.value">
                      {{ item.value }}

                      <i
                        v-if="item.value == '永久' && index == 8"
                        class="iconfont icon-question"
                      >
                            <div
                              class="hover-box"
                            >
                              会员期间下载制作完成且公开发表的作品可在授权范围内永久授权
                            </div>
                          </i>


                    </span>
                    <span v-else>
                    <i class="iconfont icon-gou"/>
                  </span>
                  </template>

                </div>
              </li>
            </ul>
          </div>

        </div>

        <div class="service-box">
          需要定制企业PLUS授权，请联系

          <a :href="PAGE_LINK.SERVICE" target="_blank" class="service">
            <i class="iconfont icon-kefu"/>
            企业专属客服
          </a>
        </div>
      </div>
    </div>


    <UseFlow/>


    <!--    <Privilege />-->
    <!--    <CustomCase class="CustomCase"/>-->
    <IntroduceCompanyCase class="IntroduceCompanyCase"/>

    <CommonProblem/>


    <CertificateDialog
      ref="CertificateDialog"
      :type="CertificateType"
    />

  </div>
</template>

<script>

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

/* 引入组件 */

/* 引入VUEX */
import {mapState} from "vuex";
import {
  COMPANY_All_PURPOSE,
  COMPANY_AUTHORIZED_SCOPE, COMPANY_PLUS_AUTHORIZED_SCOPE,
  COMPANY_RESALE,
  COMPANY_SENIOR,
  COMPANY_UPGRADE
} from "@/constant/VIP_COMPANY";
import {tag} from "@/utils/statUtil";
import CertificateDialog from "@/components/introduce/company/certificate-dialog";
import {PAGE_LINK} from "@/constant/PAGE_PATH";
import UseFlow from "@/components/introduce/company/use-flow";
import {CommonProblem, CustomCase} from "@/components/introduce/company";
import {SERVICE_LINK} from "@/constant/PATH";
import {flowStatistics} from "~/api/flow-statistics";
import IntroduceCompanyCase from "@/components/_components/introduce/company/IntroduceCompanyCase";
import {CALENDAR} from "@/constant/_Public/Path";
/* 引入API */

/* 常量 */
const MANDATE_LIST = [
  {
    id: 1,
    title: "大型企业授权模式",
    member: "（公司注册资本＞2000万）",
    list: [
      "上市企业",
      "外资企业|合资企业",
      "国企或事业单位",
      "集团公司 股份公司",
      "大企业事业部",
      "连锁企业",
    ]
  },
  {
    id: 2,
    title: "特殊用途授权模式",
    member: "（不限期不限次、永久授权）",
    list: [
      "医疗/医美/肖像权敏感用途",
      "实物转售/体恤/商品包装",
      "数字转售/课件/游戏内置",
      "影视传媒/电影/电视剧",
      "商标/LOGO产品外观",
      "买断授权/使用权/著作权",
    ]
  },
  {
    id: 3,
    title: "特殊行业授权",
    member: "（根据不同行业特性，打包授权，高性价比）",
    list: [
      "医疗医美行业",
      "房地产行业",
      "汽车行业",
      "媒体新闻行业",
      "金融行业",
      "教育行业",
    ]
  },
  {
    id: 4,
    title: "为甲方授权",
    member: "（不限制授权主体，灵活授权）",
    list: [
      "广告公司",
      "建站公司",
      "代运营公司",
      "MCN机构",
      "独立博主",
      "更多",
    ]
  }
]

const vipCardList = [
  {
    id: 10,
    label: COMPANY_All_PURPOSE.FULL_NAME2,
    name: '大型企业线上版',
    subTitle: {
      main: '1家主体',
      account: '4个帐号'
    },
    downNum: '全站200张/年（含图片包）',

    value: 2,
    ID: 10,
    PARENT_ID: COMPANY_All_PURPOSE.PARENT_ID,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    price: 8800,
    time: '/年',
    interests: [
      '「大型企业线上版」授权书',
      '针对大型企业（大于1千人）',
      '全站海量下载',
      '享5万元保障金',
    ],
    scope: [
      '新媒体用途',
      '电商用途',
      '企业办公'
    ]
  },
  {
    id: 11,
    name: '大型企业线下版',
    subTitle: {
      main: '1家主体',
      account: '4个子账号'
    },
    downNum: '全站海量下载+图片包',

    value: 2,
    ID: 11,
    PARENT_ID: COMPANY_UPGRADE.PARENT_ID,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    price: 16800,
    time: '/年',
    interests: [
      '「大型企业线下版」授权书',
      '针对大型企业（大于1千人）',
      '全站海量下载',
      '享5万元保障金',
    ],
    scope: [
      '线上全用途',
      '广告宣传',
      '线下用途',
      '传媒影视',
      '转售商品',
    ]
  },
  {
    id: 12,
    name: '医美行业专业版',
    subTitle: {
      main: '1家主体',
      account: '4个子账号'
    },
    downNum: '全站海量下载+图片包',

    value: 2,
    ID: 12,
    PARENT_ID: COMPANY_All_PURPOSE.PARENT_ID,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    price: 12800,
    time: '/年',
    interests: [
      '「医美行业专业版」授权书',
      '针对医美/医疗行业',
      '全站海量下载',
      '享5万元保障金',
    ],
    scope: [
      '线上全用途',
      '广告宣传',
      '线下用途',
      '户外广告',
      '敏感用途'
    ]
  },
  {
    id: 13,
    name: '多甲方授权版',
    subTitle: {
      main: '5家主体',
      account: '各1个子账号'
    },
    downNum: '全站海量下载+图片包',

    value: 2,
    ID: 13,
    PARENT_ID: COMPANY_RESALE.PARENT_ID,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    price: 28800,
    time: '/年',
    interests: [
      '「多甲方授权版」授权书',
      '大型企业（大于1千人）',
      '全站海量下载',
      '享5万元保障金',
    ],
    scope: [
      '线上全用途',
      '广告宣传',
      '线下用途',
    ]
  },
  {
    id: -1,
    name: '按需定制',
    /*subTitle: {
      main: '1家主体起',
      account: '1个帐号起'
    },*/
    downNum: '全站海量下载+图片包',

    value: 2,
    ID: -1,
    PARENT_ID: COMPANY_RESALE.PARENT_ID,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    price: '按需定制',
    time: '/年',
    interests: [
      '「企业PLUS定制版」授权书',
      '大型企业（大于1千人）',
      '全站海量下载',
      '享最高保障金',
    ],
    scope: [
      '按需授权',
    ]
  },

  // {
  //   label: '企业定制',
  //   subTitle:'多家主体 | 多个帐号',
  //   value: 3,
  //   // ID: -1,
  //   ID: COMPANY_All_PURPOSE.ID,
  //   price: COMPANY_All_PURPOSE.PRICE,
  //   time: '/年',
  //   desc: '多家主体 | 多个帐号',
  //   className: 'company-vip',
  //   descList: [
  //     '企业商用授权',
  //     '多主体',
  //     '多帐号',
  //     '全站海量+图片包',
  //     '￥5000/1家主体',
  //     '全球',
  //     '永久',
  //   ],
  //   permissionArr: [1, 1, 1, 1, 1, 1, 1],
  //   useSceneText: '适用企业',
  //   useScene: [
  //     {
  //       label: '线上曝光',
  //       value: '无限制'
  //     },
  //     {
  //       label: '线下印刷',
  //       value: '限5万份/一家主体'
  //     },
  //     {
  //       label: '图书出版',
  //       value: '限10万份/一家主体'
  //     },
  //     {
  //       label: '户外广告',
  //       value: true
  //     },
  //     {
  //       label: '转售商品',
  //       value: true
  //     },
  //     {
  //       label: '影视制作',
  //       value: false
  //     },
  //
  //   ],
  //   useTeam:{
  //     label:'中大型团队：',
  //     value:'支持线上/线下所有场景，可定制主体/下载帐号数量。支持户外宣传、转售商品、线下印刷、图书出版。'
  //   },
  // },
]

export default {
  name: "IntroduceCompanyPlus",

  layout: 'header-nav',
  components: {
    CertificateDialog,
    UseFlow,
    CustomCase,
    CommonProblem,
    IntroduceCompanyCase
  },
  data() {
    return {
      MANDATE_LIST,
      vipCardList,
      CertificateType: 1,
      mandateScope: COMPANY_PLUS_AUTHORIZED_SCOPE,
      PAGE_LINK,
      SERVICE_LINK,
      CALENDAR
    }
  },
  async mounted() {

    await flowStatistics({position: 'companyPlusVip'})

  },
  methods: {
    buy(vipInfo) {
      let link;
      if (vipInfo.ID === -999 || vipInfo.ID === -1) {
        link = this.SERVICE_LINK;
      } else {
        tag('充值:企业plus介绍页:图片')

        link = '/pay-company-plus/' + vipInfo.ID;
      }
      window.open(link, '_blank');

      this.$emit('buy', vipInfo)
    },

    showCertificate(item) {

      console.log(item)
      if (item.id == -1) {
        return false;
      } else {
        this.CertificateType = item.id;
        this.$refs.CertificateDialog.show = true;
      }

      /* if (idx == 4) {
         return
       }
       console.log(idx)
       this.CertificateType = idx;
       this.$refs.CertificateDialog.show = true;*/
    }
  }


}
</script>

<style lang="scss" scoped>

/* 生成8个icon的类名 */
@for $index from 0 through 6 {
  .IconItem_#{$index} {
    @include BgImageSprites(42px, 42px, "introduce/company/CompanyPlusIcons.png", 0, -$index * 42px, 42px)
  }
}

/* 生成4个授权模式icon样式 */
@for $index from 0 through 3 {
  .IconItem2_#{$index} {
    @include BgImageSprites(155px, 155px, "introduce/company/CompanyPlusIcons2.png?v=2", 0, -$index * 155px, 155px) {
    }
  }
}


/* 限时买一年送一年公共样式 */
.common-tag {
  width: 106px;
  height: 20px;
  background: linear-gradient(90deg, #FF705A 0%, #FF323B 100%);
  border-radius: 10px;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: center;
  position: absolute;
  top: -10px;
  right: 50%;
  transform: translateX(50%);

  &.right {
    border-radius: 2px 100px 2px 100px;
    right: 0;
    transform: translateX(0%);
    top: -4px;
  }
}

.container {
  margin-top: -80px;

  .header {
    @include BgImage2(100%, 715px, 'introduce/company/CompanyPlusHeader.png', 1);
    position: relative;

    .inner_center {
      width: 1200px !important;
    }

    h1 {
      height: 56px;
      font-size: 56px;
      font-weight: bold;
      color: #000000;
      line-height: 56px;
      letter-spacing: 1px;
      padding-top: 207px;
      margin-bottom: 34px;
    }

    h2 {
      height: 22px;
      font-size: 22px;
      color: #000000;
      line-height: 22px;
      letter-spacing: 1px;
      margin-bottom: 83px;
    }

    .btn-group {
      display: flex;

      .btn {
        width: 194px;
        height: 57px;
        border-radius: 5px;
        box-sizing: border-box;
        text-align: center;
        line-height: 57px;
        font-size: 20px;
      }

      .btn_consult {
        background: #255BFF;
        font-weight: bold;
        color: #FFFFFF;
        margin-right: 30px;

        &:hover {
          background: #4472FF;
        }
      }

      .btn_back {
        border: 1px solid #04081B;
        color: #03081A;

        &:hover {
          color: rgba(37, 91, 255, 1);
          border: 1px solid #255BFF;
        }
      }
    }


    .list-box {
      width: 100%;
      height: 114px;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(4px);
      @include Position(1, 4, 0, 0);


      .inner_center {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: space-between;
      }


      .list-item {
        color: rgba(241, 213, 178, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        //margin-right: 20px;
        position: relative;


        .bar {
          //width: 90px;
          //background: linear-gradient(270deg, rgba(66, 74, 113, 0) 0%, rgba(66, 74, 113, 0.64) 54%, rgba(66, 74, 113, 0) 100%);
          //box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
          //padding: 0 9px;
          margin-left: 15px;
          position: relative;

          .title {
            font-size: 14px;
            font-weight: bold;
            color: #262626;
            line-height: 14px;
            margin-bottom: 10px;
          }

          .desc {
            font-size: 12px;
            color: #707171;
            line-height: 12px;
          }

          a {
            font-size: 12px;
            color: rgba(164, 171, 177, 1);
            line-height: 12px;
            text-decoration: underline;


            &:hover {
              color: rgba(37, 91, 255, 1);
            }
          }

          .icon_float {
            display: inline-block;
            height: 18px;
            background: linear-gradient(90deg, #FF705A 0%, #FF343C 100%);
            border-radius: 100px 100px 100px 0px;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 18px;
            padding: 0 6px;
            @include Position(1, 2, 0, -25px);

          }
        }


      }
    }
  }

  .custom-service-box {
    width: 100%;
    height: 744px;
    @include BgImage2(100%, 744px, "introduce/company/custom-service-box-bg.jpg", 1);

    > .title {
      text-align: center;
      height: 104px;
      font-size: 32px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 52px;
      letter-spacing: 1px;
      margin: 60px 0 48px;
    }

    .card {
      width: 1179px;
      height: 452px;
      background: #FFFFFF;
      border-radius: 4px 100px 4px 100px;
      margin: 0 auto;
      position: relative;
      display: flex;

      .icon_service {
        @include BgImage2(234px, 416px, "introduce/company/icon_service.png");
        position: absolute;
        bottom: 0;
        right: -16px;
      }

      .icon_custom {
        font-size: 80px;
        font-weight: bold;
        color: rgba(45, 97, 254, 0.04);
        line-height: 106px;
        letter-spacing: 3px;
        position: absolute;
        left: 140px;
        bottom: -20px;
      }

      .card-left {
        width: 617px;
        height: 100%;
        box-sizing: border-box;

        ul {
          padding: 75px 0 0 84px;
          box-sizing: border-box;

          li {
            font-size: 20px;
            color: #202020;
            line-height: 24px;
            margin-bottom: 51px;

            .icon_biao {
              @include BgImage2(28px, 28px, "introduce/company/icon_biao.png");
              margin-right: 35px;
            }
          }
        }
      }

      .card-right {
        width: 561px;
        height: 452px;
        background: linear-gradient(90deg, #F3F7FF 0%, #E6EFFF 100%);
        border-radius: 0px 100px 4px 0px;

        .modal {
          @include BgImage2(303px, 210px, "introduce/company/icon_modal.png");
          position: absolute;
          top: 83px;
          right: 238px;
          padding: 40px 0 0 50px;
          box-sizing: border-box;

          .title {
            font-size: 20px;
            font-weight: bold;
            color: #2D61FE;
            line-height: 24px;
            margin-bottom: 10px;
          }

          .desc {
            font-size: 16px;
            color: #202020;
            line-height: 24px;
            margin-bottom: 24px;
          }

          .btn {
            display: inline-block;
            width: 184px;
            height: 48px;
            background: rgba(37, 91, 255, 1);
            border-radius: 24px;
            font-size: 16px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 48px;
            letter-spacing: 1px;
            text-align: center;
            cursor: pointer;

            &:hover {
              background: rgba(37, 91, 255, 0.9);
            }
          }
        }
      }
    }
  }

  .mandate-list {

    width: 1200px;
    margin: 0 auto 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .mandate-item {
      width: 282px;
      height: 442px;
      background: #F8F9FC;
      border-radius: 5px;
      padding: 30px 0 0 30px;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      background: #FFFFFF;
      box-shadow: 0px 10px 20px 0px rgba(0, 0, 26, 0.1);
      transition: all 0.3s ease-in;

      .title {
        font-size: 24px;
        font-weight: bold;
        color: #202020;
        line-height: 24px;
        letter-spacing: 1px;
        margin-bottom: 14px;
      }

      .member {
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 28px;
        color: #202020;
        white-space: nowrap;
        margin-left: -10px;
      }

      .list {
        color: #202020;
        position: relative;
        z-index: 8;

        .list-item {
          margin-bottom: 25px;
          line-height: 16px;
          font-size: 15px;

          .icon-gou2 {
            font-size: 18px;
            margin-right: 15px;
            color: #3063FF;
          }

          &:last-child {
            margin-bottom: 0;
          }

        }
      }

      > .btn {
        display: inline-block;
        width: 222px;
        height: 48px;
        background: rgba(37, 91, 255, 1);
        border-radius: 24px;
        position: relative;
        z-index: 10;
        font-size: 14px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 48px;
        letter-spacing: 1px;
        text-align: center;
        margin-top: 33px;

        &:hover {
          background: rgba(37, 91, 255, 0.8);
        }
      }

      .IconItem2 {
        transition: all 0.5s ease-in;
      }

      .IconItem2_0 {
        @include Position(1, 3, -30px, -30px);
      }

      .IconItem2_1 {
        @include Position(1, 3, -30px, -30px);
      }

      .IconItem2_2 {
        @include Position(1, 3, -30px, -30px);
      }

      .IconItem2_3 {
        @include Position(1, 3, -30px, -30px);
      }

      /*&:hover {
        background: linear-gradient(180deg, #5D98FF 0%, #3C7EFB 100%);
        margin-top: -16px;

        .icon-gou2 {
          color: #FFFFFF !important;
        }

        .title, .member, .list {
          color: #FFFFFF;
        }

        .IconItem2 {
          bottom: 0 !important;
        }
      }*/
    }
  }

  .vip-card-group {
    width: 100%;
    //position: absolute;
    //top: 356px;
    //left: 50%;
    //transform: translateX(-50%);

    height: 660px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 75%, #F5F6FA 100%);
    background: linear-gradient(180deg, #FFFFFF 0%, #F5F6FA 15%, #F5F6FA 100%);

    background-color: #fff;

    .inner_center {
      //justify-content: space-between;
      width: 1306px !important;

      > .title {
        padding: 64px 0 44px;
        font-size: 32px;
        font-weight: bold;
        color: #2D2B33;
        line-height: 42px;
        letter-spacing: 1px;
        text-align: center;
      }

      @include Screen(1) {
        //width: 1200px !important;
      }

      .card-item-list {
        display: flex;
      }
    }

    .card-item {
      width: 242px;
      height: 547px;
      background: #FFFFFF;
      box-shadow: 0px 10px 20px 0px rgba(0, 0, 26, 0.1);
      border-radius: 14px;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      margin-right: 24px;
      position: relative;
      box-shadow: 0px 10px 20px 0px rgba(0, 0, 26, 0.1);

      .icon_bug {
        @include BgImage(114px, 28px, 'pay/icon_buy.png');
        position: absolute;
        left: 50%;
        top: -8px;
        transform: translateX(-50%);
      }

      &:last-child {
        margin-right: 0;
      }


      @for $i from 1 to 6 {
        .card-header#{$i} {
          //width: #{$i}px !important;
          @include BgImage(242px, 60px, 'introduce/company/CompanyVipCardGroup//card-header-bg#{$i}.png');
        }
      }

      @mixin CardHeaderTitle($color: transparentize) {
        color: $color;
        .title, .text-main {
          color: $color;
        }
      }
      @include Screen(1) {
        width: 240px;
        margin-right: 25px;
        &:last-child {
          margin-right: 0;
        }

        @for $i from 1 to 6 {
          .card-header#{$i} {
            //width: #{$i}px !important;
            @include BgImage(240px, 60px, 'introduce/company/CompanyVipCardGroup//card-header-bg#{$i}.png');
          }
        }
      }


      .card-header {
        //background: #35D0BA;
        border-radius: 14px 14px 0px 0px;
        text-align: center;
        color: #FFFFFF;

        @include BgImage2(240px, 60px, 'introduce/company/CompanyPlusMandateHeader.png');
        /*&.card-header1 {
          @include CardHeaderTitle(rgba(177, 119, 81, 1))
        }

        &.card-header2 {
          @include CardHeaderTitle(rgba(179, 77, 41, 1))
        }

        &.card-header3 {
          @include CardHeaderTitle(rgba(137, 70, 44, 1))
        }

        &.card-header4 {
          @include CardHeaderTitle(rgba(86, 40, 5, 1))
        }

        &.card-header5 {
          @include CardHeaderTitle(rgba(52, 57, 129, 1))
        }*/

        .title {
          font-weight: bold;
          letter-spacing: 1px;

          //margin: 16px 0 4px;

          font-size: 16px;
          //color: #89462C;
          line-height: 60px;
        }

        .sub-title {
          letter-spacing: 1px;
          //color: #B17751;
          line-height: 16px;

          .text-main {

          }

          .text-account {
            color: rgba(248, 90, 31, 1);
            font-weight: bold;
          }


        }

        .desc {
          font-size: 13px;
          line-height: 18px;
        }
      }

      .card-content {
        width: 100%;
        box-sizing: border-box;
        padding: 0 24px 16px;

        .price-box {
          font-weight: bold;
          color: #2D2B33;
          text-align: center;
          padding: 12px 0 4px;
          font-size: 0;

          .icon_dollar {
            font-size: 14px;
            line-height: 19px;
          }

          .price {

            font-size: 32px;
            font-weight: bold;
            color: #2D2B33;
            line-height: 40px;
          }

          .time {
            font-size: 16px;
            line-height: 21px;
          }
        }

        .price-box2 {
          height: 28px;
          font-size: 21px;
          font-weight: bold;
          color: rgba(37, 91, 255, 1);
          line-height: 28px;
          margin: 46px 0;
          text-align: center;
        }

        .main-box {
          width: 194px;
          height: 51px;
          background: linear-gradient(270deg, rgba(245, 246, 250, 0) 0%, #F5F6FA 47%, rgba(245, 246, 250, 0) 100%);
          border-radius: 1px;
          padding: 8px 0 7px;
          text-align: center;

          .sub-title {
            letter-spacing: 1px;
            //color: #B17751;
            margin-bottom: 4px;
            font-size: 12px;
            color: #2D2B33;
            line-height: 16px;

            .text-main {

            }

            .text-account {
              //color: rgba(248, 90, 31, 1);
              //font-weight: bold;
            }


          }

          .down-num {
            font-size: 12px;
            color: #2D2B33;
            line-height: 16px;
            margin-top: 4px;
          }

        }

        .buy {
          text-align: center;
          font-weight: bold;
          position: relative;
          z-index: 5;
          width: 194px;
          height: 42px;
          line-height: 42px;
          background: rgba(37, 91, 255, 1);
          border-radius: 22px;
          font-size: 14px;
          color: #FFFFFF;

          @include ElementHover('', rgba(37, 91, 255, 0.9));
        }

        .buy-service {
          background: rgba(155, 161, 242, 0.1);
          color: rgba(37, 91, 255, 1);
          @include ElementHover(rgba(37, 91, 255, 1), rgba(155, 161, 242, 0.1));
        }

        .hr {
          border-bottom: 1px dashed #C5CBE6;
          margin: 31px 0 32px;
        }

        .permission-list {

          &.interests {
            .permission-item {
              &:first-child {
                color: #B57F34;

                @include ElementHover('', '') {
                  span {
                    text-decoration: underline;
                  }
                }
              }
            }
          }

          .permission-item {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            font-size: 12px;
            line-height: 16px;

            .icon-gou2 {
              font-size: 12px;
              color: rgba(0, 170, 116, 1);
              margin-right: 10px;
            }

            .permission-lf {
              color: #424866;
              display: flex;
              //align-items: center;
              justify-content: center;

              i {
                font-size: 18px;
                margin-right: 10px;
              }
            }


          }
        }

        .scene-hr {
          font-size: 14px;
          color: #71758C;
          line-height: 20px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 18px 0 10px;

          .scene-text {
            white-space: nowrap;
          }

          .line {
            display: inline-block;
            width: 110px;
            height: 1px;
            border-bottom: 1px dashed #C5CBE6;
          }
        }
      }

      &:hover {
        &.card-item {
          margin-top: -16px;
        }
      }

    }
  }

  .mandate-scope {
    width: 100%;
    //height: 1890px;
    //background: linear-gradient(180deg, #FFFFFF 0%, #F5F6FA 15%, #F5F6FA 100%);
    background: linear-gradient(180deg, #FFFFFF 0%, #F5F6FA 15%, #F5F6FA 100%);

    .inner_center {
      width: 1200px !important;
    }

    .title {
      font-size: 32px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 42px;
      letter-spacing: 1px;
      text-align: center;
      padding: 68px 0 56px;
    }

    .content {

      background: rgba(255, 255, 255, 0.5);
      box-shadow: inset 0px 1px 6px 0px #FFFFFF;
      border-radius: 20px;
      backdrop-filter: blur(50px);
      overflow: hidden;

      .authorization-item {
        display: flex;
        //border: 1px solid #ECEFF6;
        border-left: 0;
        box-sizing: border-box;
        border-top: 0;
        position: relative;
        //z-index: 5;
        background: #FFFFFF;

        .title {
          width: 170px;
          border-right: 1px solid #ECEFF6;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: rgba(66, 72, 102, 0.85);
          text-align: center;
          font-size: 17px;
        }

        ul {
          flex: 1;

          li {
            //height: 84px;
            //height: 80px;
            padding: 19px 16px 20px 81px;
            box-sizing: border-box;
            //border-bottom: 1px solid #ECEFF6;
            //border-right: 1px solid #ECEFF6;
            display: flex;
            //align-items: center;
            justify-content: center;
            flex-direction: column;

            &:first-child {
              background: linear-gradient(90deg, #F3F7FF 0%, #E6EFFF 100%);
              height: 57px;

              .name {
                font-size: 14px;
                font-weight: bold;
                color: #2D2B33;
              }
            }

            &:last-child {
              //border-bottom: 0;
            }

            &.NO {
              height: 57px;

              .name {
                margin-bottom: 0px;
              }
            }

            &:nth-child(1),
              //&:nth-child(11),
            &:nth-child(13),
            &:nth-child(17),
            &:nth-child(19),
            &:nth-child(21),
            &:nth-child(23),
            &:nth-child(25),
            &:nth-child(27),
            &:nth-child(29),
            &:nth-child(31),
            {
              border-right: none;
              border-bottom: none;
              margin-top: -1px;
            }


            &:nth-child(1) {

            }

            .name {
              font-size: 13px;
              color: #424866;
              line-height: 17px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              span {
                width: 340px;
                display: inline-flex;
                align-items: center;
                justify-content: center;

                .icon-gou {
                  font-size: 20px;
                  color: #4FD3C0;
                }
              }
            }

            .desc {
              //color: #424866;
              //line-height: 19px;
              //font-size: 13px;
            }
          }
        }

        &:last-child {
          border-bottom: 0;
        }
      }

    }

    .service-box {
      font-size: 14px;
      color: #424866;
      line-height: 19px;
      letter-spacing: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 39px 0 0;
      padding-bottom: 50px;

      .service {
        //width: 100px;
        height: 26px;
        border-radius: 13px;
        border: 1px solid #233E90;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        color: #233E90;
        padding: 0 10px;

        .icon-kefu {
          margin-right: 6px;

        }

        &:hover {
          background: #233E90;
          color: #FFFFFF;
          cursor: pointer;
        }
      }

    }
  }

  .UseFlow {
    margin-bottom: 80px;
    @for $i from 1 to 5 {
      /deep/ .flow-item#{$i} {
        @include BgImage2(300px, 333.33px, 'introduce/company/CompanyPlusFlow-#{$i}.png?v=2');
      }
    }

    /deep/ .flow-item1 {
      @include BgImage2(300px, 333.33px, 'introduce/company/CompanyPlusFlow-1-1.png?v=3');;
    }
  }

  /deep/ .CompanyCustomCase {
    @include BgImage2(100%, 521px, 'introduce/company/CompanyPlusCustomCase.jpg', 1);

    h2, .subhead {
      color: #FFFFFF;
    }

    .submit-btn {
      background: linear-gradient(51deg, #FFEF9E 0%, #FFD467 100%);
      color: #2D2B33;

      &:hover {
        background: linear-gradient(51deg, #FFD467 0%, #FFEF9E 100%);
      }
    }

  }
}


.container {
  /deep/ .IntroduceCompanyCase {
    height: 856px !important;
    @include BgImage(100%, 856px, 'enterprise/case/card-blue.jpg', 1);

    .title {
      //margin: 80px 0 40px;
      //color: rgba(10, 37, 64, 1);
      color: rgba(255, 255, 255, 1);
    }

    .btn-group {
      .btn-1 {
        border-color: rgba(255, 255, 255, 1);
        color: rgba(255, 255, 255, 1);
        background: transparent;
      }

      .btn-2 {
        background: linear-gradient(51deg, #FFEF9E 0%, #FFD467 100%);
        color: rgba(45, 43, 51, 1);
      }
    }

    .btn-group {
      .btn-1 {
        &:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      }

      .btn-2 {
        &:hover {
          background: linear-gradient(51deg, #FFD467 0%, #FFEF9E 100%);
        }

      }

    }
  }
}


.iconfont {
  font-size: 16px;
  //margin: 0 10px 0 24px;
}

.icon-question {
  //@include Position(1, 2, 12px, 50%);
  //transform: translateY(-50%);
  z-index: 10;
  margin: 0;
  position: relative;

  &:after {
    content: '';
    display: inline-block;
    padding: 10px;
    @include Position(1, 5, 50%, 50%);
    transform: translate(-50%, -50%);
  }

  &:hover {
    .hover-box {
      display: block;
    }
  }

  .hover-box {
    min-width: 140px;
    //height: 60px;
    background: #424866;
    border-radius: 4px;
    @include Position(1, 5, 24px, 50%);
    transform: translateY(-50%);
    font-size: 12px;
    color: #FFFFFF;
    line-height: 16px;
    padding: 6px 8px;
    display: none;
    text-align: left;

    &:after {
      display: inline-block;
      content: '';
      width: 8px;
      height: 8px;
      background: #424866;
      @include Position(1, 5, -4px, 50%);
      transform: translateY(-50%) rotate(135deg);
    }

    &:before {
      display: inline-block;
      content: '';
      width: 15px;
      height: 100%;
      @include Position(1, 4, -15px, 0);
      //background-color: pink;
    }
  }

  .hover-box2 {
    width: 180px;
  }


}


</style>
